import table from './table';
import nonInspectionTable from './nonInspectionTable';
import notClosedTable from './notClosedTable';
import {
  transform,
  transformNonInspection,
  transformNotClosed,
  transformDownloadImages
} from './transform';
import schema from './schema';
import fields from './fields';
import assetCreationFields from './assetCreationFields';
import assetCreationSchema from './assetCreationSchema';

const name = 'dvir';
const path = 'dvir';

export default {
  table,
  nonInspectionTable,
  notClosedTable,
  schema,
  fields,
  assetCreationFields,
  assetCreationSchema,
  get: {
    name,
    path: `${path}/dvir_reports`,
    transform,
    defaultValue: []
  },
  downloadDvirReport: {
    path: `${path}/download_dvir_reports`
  },
  downloadPdf: {
    path: `${path}/download_pdf`
  },
  getVehicle: {
    name: 'getVehicle',
    path: `dvir/vehicle/:barcode`,
    transform: res => res
  },
  getTemplate: {
    name: 'getTemplate',
    path: `dvir/templates/structure`
  },
  createInspection: {
    method: 'POST',
    path: `${path}/create_inspection`
  },
  updateVehicle: {
    method: 'PATCH',
    path: `${path}/update_vehicle/:id`
  },
  getNonInspection: {
    name: 'nonInspectionReport',
    path: `${path}/no_inspection_report`,
    transform: transformNonInspection,
    defaultValue: []
  },
  getNotClosedDvirs: {
    name: 'notClosedDvirs',
    path: `${path}/dvir_opened_reports`,
    transform: transformNotClosed,
    defaultValue: []
  },
  requestCreation: {
    method: 'POST',
    path: `${path}/request_create_vehicle`
  },
  downloadImages: {
    name: 'download_images',
    path: `${path}/download_images`,
    transform: transformDownloadImages
  }
};
